import { Box } from "@mui/material";
import { bottomSheetHandlePillSx, bottomSheetHandleSx } from "shared/ui/bottomSheetStyles";

export default function BottomSheetHandle() {
    return (
        <Box sx={bottomSheetHandleSx} aria-hidden>
            <Box sx={bottomSheetHandlePillSx} />
        </Box>
    );
}
